export default __webpack_public_path__ + "static/media/consult-tab-icon.f01b21e8.svg";